import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuth } from '@/features/auth'

interface UpdateProfileData {
  name: string
  email?: string
}

export function useUpdateProfile() {
  const queryClient = useQueryClient()
  const { userProfile } = useAuth()

  return useMutation({
    mutationFn: async (data: UpdateProfileData) => {
      if (!userProfile?.id) {
        throw new Error('No profile found')
      }

      const { error } = await supabase
        .from('profiles')
        .update({
          full_name: data.name,
          updated_at: new Date().toISOString(),
        })
        .eq('id', userProfile.id)

      if (error) throw error
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] })
    },
  })
}

export function useChangePassword() {
  return useMutation({
    mutationFn: async ({
      currentPassword,
      newPassword,
    }: {
      currentPassword: string
      newPassword: string
    }) => {
      // First verify current password by trying to sign in
      const { data: userData } = await supabase.auth.getUser()
      if (!userData.user?.email) {
        throw new Error('No user email found')
      }

      // Try to sign in with current password to verify it
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email: userData.user.email,
        password: currentPassword,
      })

      if (signInError) {
        throw new Error('Senha atual incorreta')
      }

      // Update to new password
      const { error: updateError } = await supabase.auth.updateUser({
        password: newPassword,
      })

      if (updateError) throw updateError
    },
  })
}
